import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=589ea0de&scoped=true&"
import script from "./ProfileDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProfileDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ea0de",
  null
  
)

export default component.exports